import classNames from 'classnames'

import style from './Button.module.scss'

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const ButtonComponent = (props: IProps) => {
    const { className, ...rest } = props
    return <button className={classNames(style.container, className)} {...rest} />
}
